import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Helmet } from "react-helmet";
import { useLocation } from "react-router-dom";
import ReactGA from "react-ga";

const useStyles = makeStyles((theme) => ({
  root: {
    height: "100vh",
    width: "100vw",
    backgroundColor: "black",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",

    overflow: "hidden",
  },
  img: {
    height: "50vh",
    objectFit: "contain",
    [theme.breakpoints.down("md")]: {
      height: "50vh",
    },
  },
}));

const Comingsoon = () => {
  const classes = useStyles();
  ReactGA.pageview(`notfound`);
  return (
    <div className={classes.root}>
      <Helmet>
        <title>Egram Panchayat</title>
        <meta name="description" content="Welcome to e-gram panchayat" />

        <meta property="og:title" content="Egram panchayat" />
        <meta property="og:url" content="https://egrampanchayat.in" />
        <meta property="og:description" content="Egram panchayat website" />
        <meta
          property="og:image"
          itemprop="image"
          content="https://egrampanchayat.in/images/otherlogos/selfmade.png"
        />
        <meta
          property="og:image:secure_url"
          itemprop="image"
          content="https://egrampanchayat.in/images/otherlogos/selfmade.png"
        />
        <meta property="og:type" content="website" />
        <meta property="og:locale" content="en_IN" />
      </Helmet>
      <img src="/images/coomingsoon.png" className={classes.img} />
    </div>
  );
};
export default Comingsoon;
